'use strict';

module.exports = {
    loadContentOnClick: function () {
        $('.bloglisting-container').on('click', '.load-more-articles', function () {
            var $this = $(this);
            var url = $this.data('href');
            if (!url) return;
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'get',
                dataType: 'json',
                success: function (data) {
                    if (data.success && data.markup !== '') {
                        $this.replaceWith(data.markup);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
